import React from "react";
import LegalPage, { Section, Bullets } from "./LegalPage";

export default function RefundPolicy() {
  return (
    <LegalPage
      testId="refund-policy-page"
      eyebrow="Legal"
      title="Refund Policy"
      lastUpdated="23 April, 2026"
    >
      <p>
        This Refund Policy explains how <strong>ResyNote</strong> handles billing, cancellations and
        refund requests for paid subscriptions.
      </p>

      <Section n="1" title="Free Trial">
        <Bullets
          items={[
            "All users are eligible for a 15-day free trial",
            "No charges apply during this period",
          ]}
        />
      </Section>

      <Section n="2" title="Subscription Payments">
        <p>After the trial:</p>
        <Bullets
          items={["₹199/month plan", "₹1999/year plan"]}
        />
        <p>Payments are charged in advance.</p>
      </Section>

      <Section n="3" title="Refund Eligibility">
        <Bullets
          items={["Payments are non-refundable once processed"]}
        />
        <p>No refunds for:</p>
        <Bullets
          items={[
            "Partial usage",
            "Unused subscription time",
            "Failure to cancel before renewal",
          ]}
        />
      </Section>

      <Section n="4" title="Exceptions (Case-by-Case)">
        <p>Refunds may be considered only if:</p>
        <Bullets
          items={[
            "Duplicate payment is made",
            "Technical issues prevent access to the service",
          ]}
        />
        <p>Users must raise a request within 7 days of payment.</p>
      </Section>

      <Section n="5" title="Cancellation Policy">
        <Bullets
          items={[
            "Users can cancel subscription anytime",
            "Access remains active until the end of the billing cycle",
            "No partial refunds after cancellation",
          ]}
        />
      </Section>

      <Section n="6" title="Billing Disputes">
        <p>
          For any billing concerns, contact:{" "}
          <a
            href="mailto:hello@resynote.com"
            className="text-blue-600 hover:underline"
            data-testid="refund-contact-email"
          >
            hello@resynote.com
          </a>
        </p>
      </Section>

      <Section n="7" title="Changes to Policy">
        <p>ResyNote reserves the right to update this policy at any time.</p>
      </Section>
    </LegalPage>
  );
}
